import React from "react";

const SocialIcons = ({ shop, list_links }) => (
    <div className="social-container flex gap-x-[12px] w-full items-center">
        <span className="bf font-semibold uppercase">{list_links.settings.top_text}</span>
        <div className="social-icons flex gap-x-[12px]">
            {shop?.social_links && Object.entries(shop.social_links).map(([platform, url]: any) => (
                <a
                    key={platform}
                    href={url}
                    className="inline-block text-[1.5rem] leading-[1px] hover:no-underline"
                    target="__blank"
                    aria-label={platform}
                >
                    <i className={`icon icon-${platform}-logo-thin`} />
                </a>
            ))}
        </div>
    </div>
);

export default SocialIcons;
